import { JobHttpModel, JobSettingsValidationResult, JobSettingsValidationResults } from '@y42/job';
import { haveEqualProps } from '@y42/util/have-equal-props';
import { DatasourceTableStoreModel } from '../../datasource-table/datasource-table.model';
import { DatasourceStoreModel } from '../../datasource/datasource.model';

export class DatasourceJobSettingsValidationService<
  StoreModel extends DatasourceStoreModel = DatasourceStoreModel,
  TableStoreModel extends DatasourceTableStoreModel = DatasourceTableStoreModel,
> {
  validate(job: JobHttpModel, table: TableStoreModel, datasource: StoreModel): JobSettingsValidationResults {
    return {
      source_settings: this.validateSourceSettings(job, datasource),
      table_settings: this.validateTableSettings(job, table),
    };
  }

  private validateSourceSettings(job: JobHttpModel, datasource: StoreModel): JobSettingsValidationResult {
    const propertiesToCompareFor = job.request.source_settings ? Object.keys(job.request.source_settings) : [];

    return {
      entityPath: datasource.$path,
      filePath: `${datasource.$path}/settings.json`,
      content1AsJson: {
        data: datasource.settings as unknown as Record<string, unknown>,
        props: propertiesToCompareFor,
      },
      content2AsJson: { data: job.request.source_settings ?? {}, props: propertiesToCompareFor },
      isValid: job.request.source_settings
        ? haveEqualProps(datasource.settings, job.request.source_settings, propertiesToCompareFor)
        : false,
    };
  }

  private validateTableSettings(job: JobHttpModel, table: TableStoreModel): JobSettingsValidationResult {
    const propertiesToCompareFor = Object.keys(job.request.table_settings);

    return {
      entityPath: table.$path,
      filePath: `${table.$path}/settings.json`,
      content1AsJson: {
        data: (table.settings as unknown as Record<string, unknown>) ?? {},
        props: propertiesToCompareFor,
      },
      content2AsJson: { data: job.request.table_settings, props: propertiesToCompareFor },
      isValid: haveEqualProps(table.settings, job.request.table_settings, propertiesToCompareFor),
    };
  }
}
